import * as ACT from './actions'
import { createReducer } from 'redux-create-reducer'

const initialState = {
  reportsBidFollowUp: []
}

const listsReducer = createReducer(initialState, {
  [ACT.BID_FOLLOW_UP_FETCH_SUCCESS](state, action) {
    const { reportsBidFollowUp } = action.payload
    return {
      ...state,
      reportsBidFollowUp
    }
  }
})

export default listsReducer
